export const DeliveryServiceConstants = {
    DELIVERY_SERVICE_TYPES: {
        FAX: "FAX",
        EMAIL: "EMAIL"
    },
  };